/* eslint-disable react/no-array-index-key */
import classnames from 'classnames';
import React, { useCallback, useState, useRef } from 'react';
import { useUpdate } from '../_utils/hooks';
import { createPrefixCls } from '../_utils/string';
import PickerCol from './picker-col';
const prefixCls = createPrefixCls('picker');
export const MultiPicker = ({ className, data, defaultValue, onChange }) => {
    const [pickerValue, setPickerValue] = useState(defaultValue);
    const pickerIndex = useRef();
    const handleChange = useCallback((colIndex) => {
        return (index) => {
            pickerIndex.current = colIndex;
            pickerValue[colIndex] = data[colIndex][index];
            setPickerValue([...pickerValue]);
        };
    }, [data, pickerValue]);
    useUpdate(() => {
        pickerIndex.current && onChange(pickerValue, pickerIndex.current);
    }, [onChange, pickerIndex, pickerValue]);
    return (React.createElement("div", { className: prefixCls('content') },
        React.createElement("div", { className: prefixCls('mask') }),
        React.createElement("div", { className: prefixCls('indicator') }),
        React.createElement("div", { className: classnames(prefixCls('cols'), className) }, data.map((el, index) => {
            return React.createElement(PickerCol, { key: index, data: el, value: pickerValue[index], onChange: handleChange(index) });
        }))));
};
export default MultiPicker;
